import { InjectionToken } from '@angular/core';
import { Config } from '../../../core';

export const CR_CONFIG = new InjectionToken<Config>('App configuration');
